export const PLOT_COLORS = {
  FOR_SALE: "#11f96670",
  SOLD: "#f518186c",
  HOLD: "#9518f56c",
  PENDING: "#ffbf0086",
  NOT_FOR_SALE: "#4584dba7",
  ROAD: "#767b837f"
};